<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>THE FAR REACHES</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="centera"><a id="page_ii"></a><img alt="Image" src="images/img_ii.jpg"/></p>
<p class="authora">Also by Homer Hickam</p>
<p class="normal2"><em>Torpedo Junction</em></p>
<p class="normal2"><em>Rocket Boys (</em>a.k.a. <em>October Sky)</em></p>
<p class="normal2"><em>Back to the Moon</em></p>
<p class="normal2"><em>The Coalwood Way</em></p>
<p class="normal2"><em>Sky of Stone</em></p>
<p class="normal2"><em>We Are Not Afraid</em></p>
<p class="normal2"><em>The Keeper’s Son</em></p>
<p class="normal2"><em>The Ambassador’s Son</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// aboutauthor.vue?3259f56c